module.exports = __webpack_public_path__ + "static/media/main-logo.d248d355.png";